import { ConfigColumns2 } from "../types/configColumns2";
import { stringContains } from "./stringUtills";

const paginate = (array: any[], page_size: number, page_number: number): any[] => {
    if (array === undefined) return [];
    if (array === null) return [];
    if (array.length === 0) return [];

    if (array.length < page_size) {
        return array;
    }

    let result = array.slice((page_number - 1) * page_size, page_number * page_size);
    return array.length > 0 && result.length === 0 ? array.slice((1 - 1) * page_size, page_number * page_size) : result;
};


const filterRowsByObject = (gridRows: any[], filterObject: any, columndata: ConfigColumns2[]): any[] => {
    if (!filterObject || Object.keys(filterObject).length === 0 || Object.keys(filterObject).every(x => filterObject[x] === "")) {
        return gridRows;
    }

    let filteredRows = gridRows.filter((row: any) => {
        let result = true;
        for (let key in filterObject) {
            let render = columndata.find(x => x.data === key)?.render;
            if (render ? !stringContains(render(row, "filter"), filterObject[key]) : !stringContains(row[key], filterObject[key])) {
                result = false;
                break;
            }
        }
        return result;
    });
    return filteredRows;
};

export { paginate, filterRowsByObject };
